import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client.js';
import { useMe, queryKeys, type CurrentUser } from '../api/queries.js';

export function orderMonthOffset(today: string, month: string | null): number {
  if (!month) return 0;
  return (Number(month.slice(0, 4)) - Number(today.slice(0, 4))) * 12
    + Number(month.slice(5, 7)) - Number(today.slice(5, 7));
}

/** Начальный период всех разделов берётся из одной личной настройки. */
export function useInitialMonth(today: string): string {
  const me = useMe();
  return me.data?.user.pinnedOrderMonth ?? today.slice(0, 7);
}

/** Источник настройки — аккаунт; локальное закрепление версии 1.8.6 игнорируется. */
export function usePinnedOrderMonth() {
  const me = useMe();
  const client = useQueryClient();
  const [pinSaving, setPinSaving] = useState(false);
  const pinnedMonth = me.data?.user.pinnedOrderMonth ?? null;
  const pinMonth = async (month: string | null): Promise<boolean> => {
    setPinSaving(true);
    try {
      const result = await api.put<{ user: CurrentUser }>('/api/me/order-month', { month });
      client.setQueryData(queryKeys.me, result);
      return true;
    } catch {
      return false;
    } finally {
      setPinSaving(false);
    }
  };
  return { pinnedMonth, pinMonth, pinSaving };
}
